import * as events from "events";

import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Domain as WebsideDomain } from "../../../lib/Domain/Webside";
import { Domain as LWFSeriesDomain } from "../../../lib/Domain/LWFSeries";
@Injectable()
export class AdrSystemService extends events.EventEmitter {
  // \lib\Server\Webside\route\api\adrsystemRoute.ts

  constructor(private http: Http) {
    super();
  }
  public async List(): Promise<LWFSeriesDomain.IDeviceInfo[]> {
    const result = await this.http
      .get("/api/adrsystem/list")
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as LWFSeriesDomain.IDeviceInfo[];
    } else {
      throw new Error(`${result.message}`);
    }
  }

  public async Realtimedata(
    gatewayId: string,
    meterId: number
  ): Promise<LWFSeriesDomain.IRealTimedata> {
    const result = await this.http
      .post("/api/adrsystem/status", {
        gatewayId,
        meterId: `${meterId}`
      } as WebsideDomain.IRAYRequest)
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as LWFSeriesDomain.IRealTimedata;
    } else {
      throw new Error(`${result.message}`);
    }
  }

  public async Historicaldata(
    gatewayId: string,
    meterId: number,
    start: Date,
    end?: Date
  ): Promise<LWFSeriesDomain.IRealTimedata[]> {
    const result = await this.http
      .post("/api/adrsystem/historical", {
        gatewayId,
        meterId: `${meterId}`,
        start,
        end
      } as WebsideDomain.IRAYRequest)
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as LWFSeriesDomain.IRealTimedata[];
    } else {
      throw new Error(`${result.message}`);
    }
  }
}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/adr-system.service.ts